import React from 'react'
import './ReturnPolicy.css'
import BannerComponent from '../Common-Component/BannerComponent/BannerComponent'
import InnerReturnPolicy from './InnerReturnPolicy/InnerReturnPolicy'

const ReturnPolicy = () => {
    return (
        <section className='ReturnPolicy AboutUs'>
            <BannerComponent img="\assets\Images\ReturnPolicy\banner.png" title="Return Policy" />

            <div className='container'>
                <div className='below_banner_section'>
                    <InnerReturnPolicy />
                </div>
            </div>
        </section>
    )
}

export default ReturnPolicy
